<template>
	<div class="page-in">
    <div v-if="page.title!=''" v-html="page.title" class="page_title title_h1 yo-color-primary"  @click.ctrl="editNow"></div>
    <div id="page"></div>
  </div>
</template>

<script>
import Vue from 'vue'
const compiler = require('vue-template-compiler')

export default {
  props: {
    filename: {
      type: String,
      default: 'home'
    },
  },
  data () {
    return {
      loading: true,
      pagefile:'',
      
      page: {title:'', testo:''}
    }
  },
  created () {
    console.log(this.filename + " Arrivo al site-page.vue con page  "+this.$route.params.filename);
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
        this.loadpage(this.filename)
    },
    loadpage(pagefile){
      
      this.loading = true      
      console.log('Provo a caricare la pagina: '+this.$teras.urlsite+'page/'+pagefile+'.html')
      
      this.$axios.page(pagefile).then( (page) => {
        
         console.log("CARICATA")
        if(page.testo=='' && pagefile!='presto-disponibile'){
          this.loadpage('presto-disponibile')
        }else{
          var res = compiler.compileToFunctions('<div id="page">'+page.testo+'</div>')
          var vm = new Vue({
            router: this.$router,
            //template: '<div id="page">'+page.testo+'</div>',
            render: res.render,
            staticRenderFns: res.staticRenderFns,
            //template: res,
            methods: {
              open(link){
                console.log(link)
                window.open(link,'_system')
              }
            }
          })
        
      
          vm.$mount('#page')
          this.page = page
          this.loading = false
        }
      }).catch((error) => {
        console.log(error)
        //this.loadpage('presto-disponibile')
        this.loading = false
      })
    },
    editNow(){
      this.$teras.page.file = this.filename
      this.$teras.page.titolo = this.page.title
      this.$teras.page.testo = this.page.testo     
      this.$router.push('/page-edit')
    }
  }
  
}

</script>
<style>
#page{
  min-height:200px;
}.page-in{
  padding:0 20px;
}



</style>
